import { api } from 'data/api/api'

import { FeedbackResp, GetFeedbackArgs } from '../types/feedback'

export const getFeedback = ({ feedbackId, localize }: GetFeedbackArgs) =>
  api.get<FeedbackResp>(`/user_feedbacks/${feedbackId}`, {
    params: { localize },
  })
